import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * 通用返回按钮组件
 * 可以自定义文本和样式
 */
export default function BackButton({ 
  text = 'Back', 
  className = '',
  showIcon = true,
  onClick = null 
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1); // 返回上一页
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center space-x-2 text-gray-400 hover:text-white transition-colors ${className}`}
    >
      {showIcon && <ArrowLeft className="w-5 h-5" />}
      <span>{text}</span>
    </button>
  );
}
